var map = {
	"./en.json": 778,
	"./en_ID.json": 729,
	"./en_MM.json": 730,
	"./en_MY.json": 731,
	"./en_PH.json": 732,
	"./en_SG.json": 733,
	"./en_TH.json": 734,
	"./en_VN.json": 735,
	"./fr.json": 2370,
	"./fr_MA.json": 1161,
	"./id.json": 2371,
	"./id_ID.json": 1162,
	"./my.json": 2372,
	"./th.json": 2373,
	"./th_TH.json": 1163,
	"./vi.json": 2374,
	"./vi_VN.json": 1164,
	"./zh.json": 2375,
	"./zh_CN.json": 1165
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2369;